/* =========================================================
   FILE: cn-homepage-membership-slider-fade.js
   Mobiler Mask-Fade des Membership-Sliders.
========================================================= */

(() => {
  'use strict';

  const SELECTOR = '[data-cn-membership-plans]';
  const initialized = new WeakSet();

  const initialize = (slider) => {
    if (!slider || initialized.has(slider)) return;
    initialized.add(slider);

    let frameId = 0;

    const update = () => {
      if (frameId) return;

      frameId = requestAnimationFrame(() => {
        frameId = 0;

        const tolerance = 2;
        const maxScrollLeft = Math.max(0, slider.scrollWidth - slider.clientWidth);
        const scrollLeft = Math.max(0, slider.scrollLeft);
        const isScrollable = maxScrollLeft > tolerance;

        slider.classList.toggle('is-scrollable', isScrollable);
        slider.classList.toggle('is-at-start', !isScrollable || scrollLeft <= tolerance);
        slider.classList.toggle(
          'is-at-end',
          !isScrollable || scrollLeft >= maxScrollLeft - tolerance
        );
      });
    };

    slider.addEventListener('scroll', update, { passive: true });

    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(update);
      observer.observe(slider);
    } else {
      window.addEventListener('resize', update, { passive: true });
    }

    update();
  };

  const initializeAll = (scope = document) => {
    scope.querySelectorAll(SELECTOR).forEach(initialize);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeAll(event.target);
  });
})();
